import GroupButtons, {
  IItemButtonGroup,
} from "../../../ui/button/groupButtons";
import BaseStep from "./baseStep";
import { EDealRequestViewType } from "./types";

interface IMeetingWithRealtorStep {
  handlePrevStep: () => void;
  handleNexStep: () => void;
  onChange: (
    data: EDealRequestViewType,
    key: "viewRealtorParticipation"
  ) => void;
  isNextStepDisabled: boolean;
  data: EDealRequestViewType | null;
  mode: "sell" | "buy";
}

const ViewRealtorParticipationStep = ({
  handlePrevStep,
  handleNexStep,
  onChange,
  isNextStepDisabled,
  data,
  mode,
}: IMeetingWithRealtorStep) => {
  const handleChange = (data: EDealRequestViewType) => {
    onChange(data, "viewRealtorParticipation");
  };

  const dataActions =
    mode === "buy"
      ? [
          {
            onClick: () => handleChange(EDealRequestViewType.WithRealtor),
            label: "Присутствует",
            variant:
              data === EDealRequestViewType.WithRealtor ? "dark" : "lightDark",
          },
          {
            onClick: () => handleChange(EDealRequestViewType.WithoutRealtor),
            label: "Отсутствует",
            variant:
              data === EDealRequestViewType.WithoutRealtor
                ? "dark"
                : "lightDark",
          },
        ]
      : [
          {
            onClick: () => handleChange(EDealRequestViewType.WithoutRealtor),
            label: "Я сам покажу квартиру",
            variant:
              data === EDealRequestViewType.WithoutRealtor
                ? "dark"
                : "lightDark",
          },
          {
            onClick: () => handleChange(EDealRequestViewType.WithRealtor),
            label: "Показ квартиры с риелтором",
            variant:
              data === EDealRequestViewType.WithRealtor ? "dark" : "lightDark",
          },
          {
            onClick: () => handleChange(EDealRequestViewType.OnlyRealtor),
            label: "Риелтор сам показывает квартиру",
            variant:
              data === EDealRequestViewType.OnlyRealtor ? "dark" : "lightDark",
          },
        ];

  const text =
    mode === "buy" ? "Риелтор присутствует на встречах:" : "Тип показа:";

  return (
    <BaseStep
      prevStep={handlePrevStep}
      nextStep={handleNexStep}
      isNextStepDisabled={isNextStepDisabled}
      text={text}
    >
      <GroupButtons data={dataActions as IItemButtonGroup[]} />
    </BaseStep>
  );
};

export default ViewRealtorParticipationStep;
